import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useForms } from "../hooks/useForms";
import "./RegistrationForm.css";

export default function Home() {
    const { forms, loading, error } = useForms();

    useEffect(() => { document.title = "Salezjanie - formularze"; }, []);

    if (loading) {
        return (
            <div className="form-container">
                <div className="form-card" style={{ textAlign: "center", padding: "3rem" }}>
                    <div className="spinner" style={{ margin: "0 auto 1rem" }}></div>
                    <p style={{ color: "#8a8580" }}>Ładowanie wydarzeń...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="form-container">
                <div className="form-card">
                    <div className="options-error">
                        Nie udało się załadować wydarzeń: {error}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="form-container">
            <div className="form-card">
                <div className="form-header">
                    <h1>Dostępne wydarzenia</h1>
                    <p className="form-subtitle">Wybierz wydarzenie, na które chcesz się zarejestrować</p>
                </div>
                
                {forms.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "2rem" }}>
                        <p style={{ color: "white" }}>Aktualnie nie ma dostępnych wydarzeń.</p>
                    </div>
                ) : (
                    <div className="options-list">
                        {forms.map(form => (
                            <Link to={`/form/${form.id}`} key={form.id} className="option-card" style={{ textDecoration: 'none', display: 'block' }}>
                                <div className="option-info">
                                    <span className="option-name">{form.title}</span>
                                    {form.subtitle && <p style={{ margin: "0.25rem 0 0", color: "#8a8580", fontSize: "0.9rem" }}>{form.subtitle}</p>}
                                </div>
                                <div className="spots-badge-wrapper">
                                    <span className="btn-small btn-save" style={{ marginLeft: "1rem" }}>Zarejestruj się →</span>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
